<template>
    <div class="app-card">
        <div class="main-info">
            <avatar :url="item.logo" :size="50" :class="{'avatar-mask': status === 1 || status === 3}"></avatar>
            <div class="text-info">
                <span class="name" :class="{cancel: status === 1 || status === 3}">{{item.name}}</span>
                <span class="status" :class="{active: status === 0, cancel: status === 1 || status === 3, connceting: status === 2}">{{statusName[status]}}</span>
                <p class="sub-status" v-if="status === 1 || status === 3">{{item.statusName}}</p>
            </div>
        </div>
        <div class="sub-info" :class="{cancel: status === 1 || status === 3}">
            <p>Vapp ID: {{item.vAppId}}</p>
            <p>up主ID：{{item.mid}}</p>
            <p>up主昵称：{{item.nickName}}</p>
        </div>
        <p class="cancel-connection">
            <span @click="cancel" class="action" v-if="status === 0">取消关联</span>
            <span @click="deleteConnection" class="action" v-if="status === 1 || status === 3">删除</span>
            <span @click="change(11)" v-if="status === 2" class="unactive sub-action">取消邀请</span>
            <span @click="copyUrl" v-if="status === 2" class="sub-action">复制邀约链接</span>
        </p>
        <textarea class="textarea" rows="1" cols="1" ref="text"></textarea>
    </div>
</template>
<script>
import Avatar from '@/components/Avatar.vue';
import dao from '@/lib/dao.js';
export default {
    components: {
        Avatar
    },
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        },
        status: {
            type: Number,
            default: 0
        },
        appPid: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

            inviteUrl: 'https://fat1-miniapp.bilibili.com/invite/smallappinvite.html?appId=', //暂为测试环境
            statusName: ['已关联', '已取消', '邀请中', '已取消']
        }
    },
    methods: {
        cancel(status) {
            this.$confirm('确认取消关联吗?取消后需重新发起邀请', '取消关联', {
                confirmButtonText: '取消关联',
                cancelButtonText: '放弃',
                type: 'warning'
            }).then(() => {
                this.change(12);
            }).catch(() => {
                    
            });
        },
        change(status) {
            dao.shop.cancelAction({
                status,
                appId: this.item.vAppId,
                appPid: this.appPid
            }).then(_ => {
                this.$emit('refresh');
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        deleteConnection() {
            dao.shop.deleteConnection({
                appId: this.item.appId,
                appPid: this.appPid
            }).then(_ => {
                this.$emit('refresh');
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        copyUrl() {
            let copyInput = this.$refs.text;
            copyInput.value = this.inviteUrl + this.item.appId;
            copyInput.select();
            document.execCommand('copy');
            this.$message.success('复制成功！');
        },
    }
}
</script>
<style lang="less" scoped>
.app-card {
    width: 310px;
    height: 155px;
    border: 1px solid #E0E5EC;
    border-radius: 4px;
    padding: 12px;
    position: relative;
    display: inline-block;
    overflow: hidden;
    box-sizing: border-box;

    .main-info {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        border-bottom: 1px dashed #E0E5EC;
        padding-bottom: 14px;
        margin-bottom: 9px;
        position: relative;

        .avatar-mask::after {
            position: absolute;
            content: '';
            width: 50px;
            height: 50px;
            border-radius: 30px;
            background: rgba(255, 255, 255, .6);
            left: 0;
            top: 0;
        }

        .text-info {
            margin-left: 10px;
            position: absolute;
            top: 42%;
            transform: translateY(-50%);
            left: 50px;
            line-height: 0;

            .name {
                font-size: 14px;
                line-height: 22px;
                word-break: break-all;

                &.cancel {
                    color: #99A2AA;
                }
            }

            .status {
                font-size: 12px;
                line-height: 18px;
                text-align: center;
                border: 1px solid;

                &.active {
                    color: #43CE5B;
                    border-color: #BAE8B3;
                    background: #F6FFF8;
                }

                &.cancel {
                    color: #99A2AA;
                    border-color: #F3F8FF;
                    background: #F3F8FF;
                }

                &.connceting {
                    color: #F5A623;
                    border-color: #FFE9C5;
                    background: #FFF8DC;
                }
            }
            .sub-status {
                color: #99A2AA;
                font-size: 12px;
                line-height: 12px;
            }
        }
    }

    .sub-info {
        color: #5C667E;
        font-size: 12px;

        &.cancel {
            color: #9AA7C1;
        }

        &>p {
            line-height: 17px;
            margin-bottom: 4px;
        }
    }

    &:hover>.cancel-connection {
        transform: translateY(0);
    }
    .cancel-connection {
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translateY(34px);
        transition: all 0.3s;
        background: #F3F4F9;
        line-height: 64px;
        cursor: pointer;
        color: #789AFF;
        text-align: center;
        width: 100%;
        height: 34px;
        line-height: 34px;
        font-size: 0;

        .sub-action {
            display: inline-block;
            vertical-align: top;
            width: 50%;
            font-size: 12px;
            &.unactive {
                color: #6D757A;
            }
        }

        .action {
            font-size: 12px;
            width: 100%;
            display: inline-block;
        }
    }
    .textarea {
        position: absolute;
        z-index: -1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ConnectionCard.vue